import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { Col, Container, Row, Input, Label, Spinner } from "reactstrap";
import { contactUs } from "../../api/contacts";
//Import Images
import contactImage from "../../assets/images/contact.png";
// import ReCAPTCHA from "react-google-recaptcha";
import { useSelector } from "react-redux";
import { getSettingByKey, isValidMobile } from "../../helpers/common";
import { CustomSnackbar } from "../../helpers/CustomSnackbar";

const ContactContent = () => {
  const [errors, setErrors] = useState({});
  const initialState = {
    name: "",
    emailAddress: "",
    contactNumber: "",
    subject: "",
    message: "",
  };
  const [loading, setLoading] = React.useState(false);

  const [formData, setFormData] = useState(initialState);
  const settings = useSelector((state) => state.settings.data);

  // Company Info
  const companyAddress = getSettingByKey(settings, "company_address")?.value;
  const companyEmailAddress = getSettingByKey(settings, "company_email_address")?.value;
  const company_contact_number = getSettingByKey(settings, "company_contact_number")?.value;

  const onChangeValue = (e) => {
    setErrors({ ...errors, [e.target.name]: null });
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onNumberInputChange = (e) => {
    setErrors({ ...errors, [e.target.name]: null });
    const inputValue = e.target.value;
    if (!inputValue) {
      setFormData({ ...formData, [e.target.name]: "" });
      return;
    }
    if (!/^\d+$/.test(inputValue)) return;
    setFormData({ ...formData, [e.target.name]: inputValue });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name) { CustomSnackbar.warning("Name is required!"); return; }
    if (!formData.emailAddress) { CustomSnackbar.warning("Email address is required!"); return; }
    if (formData.contactNumber && !isValidMobile(formData.contactNumber)) {
      CustomSnackbar.warning("Please enter valid mobile number"); return;
    }
    if (!formData.subject) { CustomSnackbar.warning("Subject is required!"); return; }
    if (!formData.message) { CustomSnackbar.warning("Message is required!"); return; }

    setLoading(true);
    contactUs({ ...formData, AdditionalFields: { position: "", company_website: "" } })
      .then(() => {
        setFormData(initialState);
        CustomSnackbar.success("Message sent successfully.");
      })
      .catch((err) => {
        CustomSnackbar.error(err?.message || "Error occurred");
      })
      .finally(() => setLoading(false));
  };

  return (
    <React.Fragment>
      <section className="section">
        <Container>
          <Row className="align-items-center mt-5">

            {/* LEFT SIDE: Image and Contact Details */}
            <Col lg={5}>
              <div className="text-center">
                <img src={contactImage} alt="Contact Us" className="img-fluid" />
              </div>
              <div className="mt-4 pt-3">
                {/* <div className="d-flex text-muted align-items-center mt-2">
                  <div className="flex-shrink-0 fs-22 text-primary">
                    <i className="uil uil-map-marker"></i>
                  </div>
                  <div className="flex-grow-1 ms-3">
                    <p className="mb-0">{companyAddress}</p>
                  </div>
                </div> */}
                <div className="d-flex text-muted align-items-center mt-2">
                  <div className="flex-shrink-0 fs-22 text-primary">
                    <i className="uil uil-envelope"></i>
                  </div>
                  <div className="flex-grow-1 ms-3">
                    <p className="mb-0">{companyEmailAddress}</p>
                  </div>
                </div>
                <div className="d-flex text-muted align-items-center mt-2">
                  <div className="flex-shrink-0 fs-22 text-primary">
                    <i className="uil uil-phone-alt"></i>
                  </div>
                  <div className="flex-grow-1 ms-3">
                    <p className="mb-0">{company_contact_number}</p>
                  </div>
                </div>
              </div>
            </Col>

            {/* RIGHT SIDE: Contact Form */}
            <Col lg={6} className="ms-auto mt-4 mt-lg-0">
              <div className="section-title">
                <h3 className="title">Get in touch</h3>
                <p className="text-muted">At Webvi, every enquiry is treated with the same care and professionalism we bring to every placement. Reach out us through any of the channels below, and a member of our team will respond promptly usually within a few hours.
                </p>
                <Form
                  method="post"
                  className="contact-form mt-4"
                  onSubmit={onSubmit}
                  id="myForm"
                >
                  <Row>
                    <Col lg={12}>
                      <div className="mb-3">
                        <Label htmlFor="name" className="form-label">Name</Label>
                        <Input type="text" name="name" id="name" className="form-control" placeholder="Enter your name" value={formData.name} onChange={onChangeValue} />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <Label htmlFor="emailAddress" className="form-label">Email</Label>
                        <Input type="email" className="form-control" id="email" name="emailAddress" placeholder="Enter your email" value={formData.emailAddress} onChange={onChangeValue} />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <Label htmlFor="contactNumber" className="form-label">Mobile Number</Label>
                        <Input type="text" className="form-control" id="contactNumber" name="contactNumber" placeholder="Enter mobile number" value={formData.contactNumber} onChange={onNumberInputChange} maxLength={10} />
                      </div>
                    </Col>
                    <Col md={12}>
                      <div className="mb-3">
                        <Label htmlFor="subject" className="form-label">Subject</Label>
                        <Input type="text" className="form-control" name="subject" placeholder="Enter subject" value={formData.subject} onChange={onChangeValue} />
                      </div>
                    </Col>
                    <Col lg={12}>
                      <div className="mb-3">
                        <Label htmlFor="message" className="form-label">Your Message</Label>
                        <textarea className="form-control" placeholder="Enter your message" name="message" rows="3" value={formData.message} onChange={onChangeValue}></textarea>
                      </div>
                    </Col>
                  </Row>

                  <div className="text-end">
                    <button className={`btn btn-primary ${loading ? 'disabled' : ''}`} type="submit">
                      {loading ? <>Sending... <Spinner size="sm" /></> : <>Send Message <i className="uil uil-message ms-1"></i></>}
                    </button>
                  </div>
                </Form>
              </div>
            </Col>

          </Row>
        </Container>
      </section>

      {/* Info Boxes Section */}
  
    </React.Fragment>
  );
};

export default ContactContent;
